<template>
	<div>
		<div class="bg-box">
			<img class="bg-img" src="./bg.png" alt />
		</div>
		<div class="login_box">
			<!-- <div >登录</div> -->
			<div class="login">
				<div class="logo">
					<div class="logo_img" style="margin-right: 5px;">
						<img src="../../assets/image/logo1.png" alt />
					</div>
					<div class="logo_text" />
					<div class="line" />
					<div class="logo_text2">后台系统</div>
				</div>
				<div class="login_box2">
					<div class="inpt">
						<div class="text">用户名</div>
						<el-input placeholder="请输入用户名" v-model="phone" />
					</div>
					<div class="inpt">
						<div class="text">密码</div>
						<el-input type="password" placeholder="请输入密码" v-model="password" />
					</div>
					<div class="inpt" style="margin-bottom: 10px;">
						<div class="text">验证码</div>
						<el-input placeholder="请输入验证码" v-model="Verification">
							<div id="v_container" slot="append" title="点击刷新验证码"></div>
						</el-input>
					</div>
					<div style="height:40px;">
						<el-checkbox>自动登录</el-checkbox>
					</div>
					<div class="btn" @click="login">登录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		GVerify
	} from "../../assets/js/verifyCode.js";
	export default {
		data() {
			return {
				verifyCode: null,
				phone: "",
				password: "",
				Verification: "", //验证码
			};
		},
		mounted() {
			if (localStorage.getItem("serrmsg")) {
				this.$message.error(localStorage.getItem("serrmsg"))
				window.localStorage.removeItem('serrmsg')
				// this.localStorage.removeItem("serrmsg")
			}
			if (localStorage.getItem("Authorization")) {
				this.$router.push({
					path: `/home`,
				})
			}
			this.verifyCode = new GVerify("v_container");
		},
		methods: {
			login() {
				if (this.phone == "" || this.password == "" || this.Verification == "") {
					this.$message.error("账号或密码或验证码不能为空！")
				} else {
					if (this.Verification == this.verifyCode.options.code.substr(-4)) {
						var a = {
							account: this.phone,
							password: this.password
						}
						this.$http.post("login", JSON.stringify(a)).then(function(res) {
							// debugger
							if (res.body.code == 200) {
								console.log(res.data)
								var header = JSON.stringify(res.header);
								console.log("成功")
								console.log(res)
								// console.log(this.getResponseHeader("Set-Cookie"));
								localStorage.setItem('adminId', res.body.data.id)
								localStorage.setItem('Authorization', res.body.data.token)
								console.log(res.body.data)
								this.$router.push({
									path: `/home`,
								})
							} else {
								this.$message.error(res.body.msg)
							}
							// if(res.body.data){
							//   if(res.body.data.user.role==0){
							//     _this.userToken =res.body.data.token;
							//     _this.usernameToken =res.body.data.user.uname;
							//     // 将用户token保存到vuex中
							//     _this.changeLogin({ Authorization: _this.userToken });
							//     _this.userlogin({ usernames: _this.usernameToken });
							//     // window.sessionStorage.setItem('userid',res.body.data.id)
							//     this.$router.push('/content/datastatistics')
							//   }else{
							//     alert('您不是管理人员')
							//   }
							// }else{
							//   alert('账号或者密码不正确')
							// }

						}, function(err) {
							this.$message.error("请求失败")
						})
					} else {
						this.$message.error("验证码错误！")
					}
				}
			}
		},
	};
</script>
<style scoped>
	@import "login.css";
</style>